<script>
  export let size = "24";
  export let color = "#252B37";
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.875 2.875C9.875 2.39102 9.48398 2 9 2C8.51602 2 8.125 2.39102 8.125 2.875V9.51133L6.11797 7.5043C5.77617 7.1625 5.22109 7.1625 4.8793 7.5043C4.5375 7.84609 4.5375 8.40117 4.8793 8.74297L8.3793 12.243C8.72109 12.5848 9.27617 12.5848 9.61797 12.243L13.118 8.74297C13.4598 8.40117 13.4598 7.84609 13.118 7.5043C12.7762 7.1625 12.2211 7.1625 11.8793 7.5043L9.875 9.51133V2.875ZM3.75 11.625C2.78477 11.625 2 12.4098 2 13.375V14.25C2 15.2152 2.78477 16 3.75 16H14.25C15.2152 16 16 15.2152 16 14.25V13.375C16 12.4098 15.2152 11.625 14.25 11.625H11.4746L10.2359 12.8637C9.55234 13.5473 8.44492 13.5473 7.76133 12.8637L6.52539 11.625H3.75ZM13.8125 13.1562C13.9865 13.1562 14.1535 13.2254 14.2765 13.3485C14.3996 13.4715 14.4688 13.6385 14.4688 13.8125C14.4688 13.9865 14.3996 14.1535 14.2765 14.2765C14.1535 14.3996 13.9865 14.4688 13.8125 14.4688C13.6385 14.4688 13.4715 14.3996 13.3485 14.2765C13.2254 14.1535 13.1562 13.9865 13.1562 13.8125C13.1562 13.6385 13.2254 13.4715 13.3485 13.3485C13.4715 13.2254 13.6385 13.1562 13.8125 13.1562Z"
    style="fill: {color} !important;"
  />
</svg>
